<script lang="ts">
  import type { Snippet } from 'svelte'
  import BrandMark from '../../components/BrandMark.svelte'
  import ThemeToggle from '../../components/ThemeToggle.svelte'
  import { brandStore } from '$lib/public/brand-store.svelte'

  interface Props {
    children?: Snippet
  }
  const { children }: Props = $props()

  const brand = $derived(brandStore.current?.pm ?? null)
</script>

<svelte:head>
  <title>RentReadyPet - Register your pet</title>
</svelte:head>

<div class="public-shell">
  <header class="public-header">
    <div class="header-inner">
      <div class="brand">
        {#if brand}
          {#if brand.logoUrl}
            <img class="brand-logo" src={brand.logoUrl} alt={brand.displayName} />
          {:else}
            <span class="brand-pm-name">{brand.displayName}</span>
          {/if}
        {:else}
          <BrandMark size={30} decorative />
          <span class="brand-name">Rent<span class="brand-accent">Ready</span>Pet</span>
        {/if}
      </div>
      <ThemeToggle />
    </div>
  </header>

  <main class="public-main">
    {#if children}
      {@render children()}
    {/if}
  </main>

  {#if brand?.supportEmail || brand?.supportPhone}
    <footer class="public-footer">
      <div class="footer-inner">
        <span>Questions? Contact {brand.displayName}:</span>
        {#if brand.supportEmail}
          <a href="mailto:{brand.supportEmail}">{brand.supportEmail}</a>
        {/if}
        {#if brand.supportPhone}
          <span>{brand.supportPhone}</span>
        {/if}
      </div>
    </footer>
  {/if}
</div>

<style>
  .public-shell {
    min-height: 100vh;
    background: var(--surface);
    display: flex;
    flex-direction: column;
  }
  .public-header {
    background: var(--surface-2);
    border-bottom: 1px solid var(--line);
    padding: 16px 24px;
  }
  .header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 720px;
    margin: 0 auto;
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 1.1rem;
    color: var(--ink-strong);
  }
  .brand-accent {
    /* --link is the text-tuned accent (AA on the card in both themes);
       --brand is only 3.7:1 on the dark card. */
    color: var(--link);
  }
  .brand-logo {
    max-height: 40px;
    width: auto;
  }
  .brand-pm-name {
    font-weight: 700;
  }
  .public-footer {
    background: var(--surface-2);
    border-top: 1px solid var(--line);
    padding: 16px 24px;
  }
  .footer-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    max-width: 720px;
    margin: 0 auto;
    font-size: 0.9rem;
    color: var(--muted);
  }

  .public-main {
    flex: 1;
    padding: 20px 24px 32px;
    max-width: 720px;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
  }
</style>
